// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.GetLandlordPaymentSettingsWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings,
  GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings_Path,
} from '@zg-rentals/ts-rent-payment-client';

import type {
  GetLandlordPaymentSettingsWebApiRequestDto,
  GetLandlordPaymentSettingsWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export type GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings_Options = UseQueryOptions<
  GetLandlordPaymentSettingsWebApiResponseDto,
  unknown,
  GetLandlordPaymentSettingsWebApiResponseDto,
  Array<string | GetLandlordPaymentSettingsWebApiRequestDto>
>;

const GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings_GetKey = (
  postData: GetLandlordPaymentSettingsWebApiRequestDto,
) => [GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings_Path, postData];

/**
 * Get landlord payment settings
 */
export const useGetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings = (
  postData: GetLandlordPaymentSettingsWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings_GetKey(postData),
    queryFn: () => GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings(postData, httpClient),
  });
};
useGetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings.getKey =
  GetLandlordPaymentSettingsWebApiHandler_getLandlordPaymentSettings_GetKey;
